import { upsellClickedEvent, upsellViewedEvent, } from '#pplx/frontend/apps/ask/events/unified-upsell/analytics.js';
import { sideUpsellClickedEvent } from '#pplx/frontend/apps/ask/events/upsell-slots/analytics.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
const bannerUpsellClickedEvent = EVENT_PAYLOAD;
const ntpBannerUpsellClickedEvent = EVENT_PAYLOAD;
const threadUpsellBannerClickedEvent = EVENT_PAYLOAD;
const upsellModalOpenedEvent = EVENT_PAYLOAD;
export const trackUpsellActionEvent = ({ runtime, upsellInformation, selectedActionOption, }) => {
    if (!upsellInformation.upsell_type || !upsellInformation.name) {
        return;
    }
    const upsellInfo = {
        ...(selectedActionOption && {
            selectedActionOptionId: selectedActionOption.id,
            selectedAmountCents: selectedActionOption.amount_cents,
        }),
        upsellType: upsellInformation.upsell_type,
        upsellName: upsellInformation.name,
        upsellUuid: upsellInformation.upsell_uuid,
        eventMetadata: upsellInformation.event_metadata,
        cometSurface: runtime.cometSurface,
        // `runtime.subscriptionTier` is loosely typed `unknown` by the runtime; it's a subscription-tier
        // string at runtime. Narrow it to the registry payload's `string` here at the translation seam.
        subscriptionTier: runtime.subscriptionTier,
    };
    switch (upsellInformation.app_location) {
        case 'MODAL':
            runtime.track(upsellModalOpenedEvent({
                name: 'upsell modal opened',
                data: {
                    ...upsellInfo,
                    entryUUID: runtime.lastResult?.backend_uuid,
                },
            }));
            break;
        case 'IN_THREAD':
        case 'IN_THREAD_BOTTOM':
        case 'IN_THREAD_INPUT':
        case 'IN_THREAD_BLOCKING_BANNER':
            runtime.track(threadUpsellBannerClickedEvent({
                name: 'thread upsell banner clicked',
                data: {
                    ...upsellInfo,
                    entryUUID: runtime.lastResult?.backend_uuid,
                    cta: upsellInformation.cta,
                },
            }));
            break;
        case 'SIDEBAR':
        case 'SIDE_CARD':
            runtime.track(sideUpsellClickedEvent({ name: 'side upsell clicked', data: upsellInfo }));
            break;
        case 'BANNER':
            runtime.track(bannerUpsellClickedEvent({ name: 'banner upsell clicked', data: upsellInfo }));
            break;
        case 'COMET_NTP_BANNER':
            runtime.track(ntpBannerUpsellClickedEvent({ name: 'ntp banner upsell clicked', data: upsellInfo }));
            break;
        default:
            break;
    }
    const data = {
        ...upsellInfo,
        upsellLocation: upsellInformation.app_location ?? 'UPSELL_APP_LOCATION_UNSPECIFIED',
        entryUUID: runtime.lastResult?.backend_uuid,
        cta: upsellInformation.cta,
    };
    runtime.impression(upsellInformation.app_location === 'MODAL'
        ? upsellViewedEvent({ name: 'upsell viewed', data })
        : upsellClickedEvent({ name: 'upsell clicked', data }));
};
//# sourceMappingURL=trackUpsellActionEvent.js.map